// @flow
import * as React from 'react'
import styled from 'styled-components'
import tw from 'tailwind-styled-components'

type Props = {
  type?: string,
  onFocus?: () => void,
  onBlur?: () => void,
}

const BlankInput: React.ComponentType<Props> = tw.input`
  w-full
  bg-transparent
  border-0
  focus:outline-none
  placeholder-gray-300
`

const StyledInput: React.ComponentType<Props> = styled(BlankInput)`
  font-weight: inherit;
  cursor: inherit;
`

export default StyledInput
